import React, { Component } from 'react';
import { connect } from 'react-redux';
import UI from 'editor-ui-lib';
import Main from './modules/main/main';
import Layout from './modules/layout/layout';
import Support from './modules/support/support';
import Settings from './modules/settings/settings';
import Design from './modules/design/design';
import Wix from "Wix";
import WixBiService from "../../../utils/WixBIService"
import {FormattedMessage} from 'react-intl';
import { injectIntl } from 'react-intl';


class AdUnitControlPanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    this.onChange = this.onChange.bind(this);
    }
    
    componentDidMount(){
        Wix.Settings.setHelpArticle("cc3ef087-ac4d-4319-8b66-ba6bc1c07a0d", { type: "SETTINGS" });
    }

    componentWillReceiveProps(newProps){
        if (newProps.dataPublic && newProps.dataPublic.userName && newProps.dataPublic.activeFileId){
            this.refs.tabs.removeTabNotification('0');
        }
        if(newProps.dataPublic && newProps.dataPublic.userName && !newProps.dataPublic.activeFileId && this.refs.tabs.state.activeTabIndex > 0){
            this.refs.tabs.showTabNotification('0',this.props.intl.formatMessage({id: 'settings.settings.notification.selectFile'}));
        }
    }
    connectBI(tab,desc) {
        WixBiService.triggerEvent('connect_google_account', {
            button_description: desc,
            tab_name: tab
        })
    }

    onChange(tab) {
        if (tab != undefined) {
            let ArticlesID;
            switch(tab){
                case 0://Main
                    ArticlesID = "cc3ef087-ac4d-4319-8b66-ba6bc1c07a0d"
                    break;
                case 1://Settings
                    ArticlesID = "f58f2717-a6b1-4f7c-8c06-a95a066967a5"
                    break;
                case 2://Design
                    ArticlesID = "12fcd47e-daf8-4ffd-be03-3c96b178e3ce"
                    break;
                case 3://Support
                    ArticlesID = "194f5308-5a76-4591-bc55-a3bb8c5abf7c"
                    break;
            }
            Wix.Settings.setHelpArticle(ArticlesID, { type: "SETTINGS" });
            }
        }

    render() {
        return ( 
            <UI.appSettings>
                <UI.panelTabs 
                    ref="tabs"
                    defaultTabIndex={0}
                    onChange={data => this.onChange(data)}
                >
                    <Main
                        tab={this.props.intl.formatMessage({id: 'settings.tab.Main'})}
                        connectBI = {(tab, desc) => this.connectBI(tab,desc)}
                    />
                    <Settings 
                        tab={this.props.intl.formatMessage({id: 'settings.tab.Settings'})}
                        connectBI = {(tab, desc) => this.connectBI(tab,desc)}
                    />
                    {/* <Layout
                         tab={'Layout'}
                    /> */}
                    <Design 
                        tab={this.props.intl.formatMessage({id: 'settings.tab.Design'})}
                    /> 
                    <Support
                        tab={this.props.intl.formatMessage({id: 'settings.tab.Support'})}
                    />
                </UI.panelTabs>
            </UI.appSettings>
        )
    }
}

const mapStateToProps = state => ({
    dataPublic: state.dataPublicReducer.dataPublic,
});

export default injectIntl(connect(mapStateToProps)(AdUnitControlPanel));



// WEBPACK FOOTER //
// ./src/settings/Containers/gdUnitControlPanel/gdUnitControlPanel.js